import { fromJS, List, Record } from 'immutable';
import { handleActions } from 'flux-actions';
import { AppActionTypes } from '../actions/AppActions';
import { UpdatePasswordActionTypes } from '../actions/ProfileActions';
import { UnrecoverableErrorActionTypes } from '../actions/UnrecoverableErrorActions';
import { TwoFactorAuthActionTypes } from '../actions/TwoFactorAuthActions';
import TwoFactorAuthSMSErrors from '../constants/TwoFactorAuthSMSErrors';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import { SecurityPhoneNumberActionTypes } from '../actions/security/SecurityPhoneNumberActions';
import { DeletePasskeyActionTypes, RenamePasskeyActionTypes, TOGGLE_PASSKEY_DELETE_MODAL, TOGGLE_PASSKEY_RENAME_MODAL } from '../actions/PasskeysActions';
export class ErrorState extends Record({
  unrecoverableErrors: List()
}) {}
const initialState = fromJS({
  updatePassword: undefined,
  unrecoverableErrors: List(),
  phoneValidation: null,
  deleteNumberError: undefined
});
function getMessageSafely(error) {
  let message;
  try {
    message = JSON.parse(error.data).message;
  } catch (e) {
    message = error.data;
  }
  return message;
}
export default handleActions({
  [UpdatePasswordActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const error = action.payload.data;
    return state.set('updatePassword', error ? fromJS({
      status: error.status,
      statusText: error.statusText,
      message: getMessageSafely(error)
    }) : undefined);
  },
  [UpdatePasswordActionTypes.FAILURE](state, action) {
    if (!action.payload) {
      return state;
    }
    const {
      error
    } = action.payload;
    return state.set('updatePassword', fromJS({
      status: error.status,
      statusText: error.statusText,
      message: getMessageSafely(error)
    }));
  },
  [UpdatePasswordActionTypes.REQUEST](state) {
    return state.set('updatePassword', undefined);
  },
  [AppActionTypes.TOGGLE_CHANGE_PASSWORD_MODAL](state) {
    return state.set('updatePassword', undefined);
  },
  [UnrecoverableErrorActionTypes.CREATE_UNRECOVERABLE_ERROR](state, action) {
    if (!action.payload) {
      return state;
    }
    const errorAction = action.payload;
    if (!errorAction.payload) {
      return state;
    }
    const {
      error
    } = errorAction.payload;
    return state.set('unrecoverableErrors', state.get('unrecoverableErrors').push(fromJS({
      time: Date.now(),
      type: errorAction.type,
      status: error.status,
      statusText: error.statusText,
      message: getMessageSafely(error)
    })));
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const {
      response
    } = action.payload;
    if (response.isValid === false) {
      return state.set('phoneValidation', TwoFactorAuthSMSErrors.NOT_VALID_NUMBER);
    }
    if (response.geoPermission === TwoFactorAuthSMSErrors.NOT_ALLOWED) {
      return state.set('phoneValidation', TwoFactorAuthSMSErrors.UNSUPPORTED_COUNTRY);
    }
    return state.merge({
      phoneValidation: null,
      isErrorSendingSMS: undefined
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_FAILURE](state) {
    return state.set('phoneValidation', null);
  },
  [TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_FAILURE](state, action) {
    if (state.method === TwoFactorAuthMethods.SMS) {
      if (!action.payload) {
        return state;
      }
      const {
        context
      } = action.payload;
      if (context.errStatus === TwoFactorAuthSMSErrors.UNSUPPORTED_COUNTRY) {
        return state.set('phoneValidation', TwoFactorAuthSMSErrors.UNSUPPORTED_COUNTRY);
      }
      return state.set('phoneValidation', TwoFactorAuthSMSErrors.NOT_VALID_NUMBER);
    }
    return state;
  },
  [TwoFactorAuthActionTypes.CANCELLED_2FA_SETUP](state) {
    return state.set('phoneValidation', null);
  },
  [SecurityPhoneNumberActionTypes.CANCELLED_SETUP](state) {
    return state.set('phoneValidation', null);
  },
  [SecurityPhoneNumberActionTypes.DELETE_SECURITY_NUMBER_FAILURE](state) {
    return state.set('deleteNumberError', true);
  },
  [AppActionTypes.TOGGLE_DELETE_TRUSTED_NUMBER_MODAL](state) {
    return state.set('deleteNumberError', undefined);
  },
  [DeletePasskeyActionTypes.FAILURE](state) {
    return state.set('deletePasskeyError', true);
  },
  [RenamePasskeyActionTypes.FAILURE](state) {
    return state.set('renamePasskeyError', true);
  },
  [TOGGLE_PASSKEY_RENAME_MODAL](state) {
    return state.set('renamePasskeyError', false);
  },
  [TOGGLE_PASSKEY_DELETE_MODAL](state) {
    return state.set('deletePasskeyError', false);
  }
}, initialState);